module.exports = __webpack_public_path__ + "static/img/card_gif.8fa65f1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/card_gif.gif
// module id = NnHs
// module chunks = 1